import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBodyClass from 'vue-body-class'
import Home from '../views/Home.vue'
import TuTru from '../views/TuTru'
import TuVi from '../views/TuVi'
import TuVi2 from '../views/TuVi2'
import LucHao from '../views/LucHao'
import TrachNhat from '../views/TrachNhat'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/tu-tru',
    name: 'TuTru',
    meta: { bodyClass: 'bg-common' },
    component: TuTru
  },
  {
    path: '/tu-vi',
    name: 'TuVi',
    meta: { bodyClass: 'bg-common' },
    component: TuVi
  },
  {
    path: '/tu-vi2',
    name: 'TuVi2',
    meta: { bodyClass: 'bg-common' },
    component: TuVi2
  },
  {
    path: '/luc-hao',
    name: 'LucHao',
    meta: { bodyClass: 'bg-common' },
    component: LucHao
  },
  {
    path: '/lich-tot-xau',
    name: 'TrachNhat',
    meta: { bodyClass: 'bg-trach-nhat' },
    component: TrachNhat
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

const vueBodyClass = new VueBodyClass(routes)
router.beforeEach((to, from, next) => { vueBodyClass.guard(to, next) })

export default router
